/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonthlyRevenue } from './MonthlyRevenue';
import {
    MonthlyRevenueFromJSON,
    MonthlyRevenueFromJSONTyped,
    MonthlyRevenueToJSON,
    MonthlyRevenueToJSONTyped,
} from './MonthlyRevenue';
import type { MonthlyReceivables } from './MonthlyReceivables';
import {
    MonthlyReceivablesFromJSON,
    MonthlyReceivablesFromJSONTyped,
    MonthlyReceivablesToJSON,
    MonthlyReceivablesToJSONTyped,
} from './MonthlyReceivables';
import type { MonthlyPayments } from './MonthlyPayments';
import {
    MonthlyPaymentsFromJSON,
    MonthlyPaymentsFromJSONTyped,
    MonthlyPaymentsToJSON,
    MonthlyPaymentsToJSONTyped,
} from './MonthlyPayments';
import type { ClaimFinancialRow } from './ClaimFinancialRow';
import {
    ClaimFinancialRowFromJSON,
    ClaimFinancialRowFromJSONTyped,
    ClaimFinancialRowToJSON,
    ClaimFinancialRowToJSONTyped,
} from './ClaimFinancialRow';

/**
 * 
 * @export
 * @interface CompanyFinancialsResponse
 */
export interface CompanyFinancialsResponse {
    /**
     * 
     * @type {Array<ClaimFinancialRow>}
     * @memberof CompanyFinancialsResponse
     */
    claims: Array<ClaimFinancialRow>;
    /**
     * 
     * @type {Array<MonthlyReceivables>}
     * @memberof CompanyFinancialsResponse
     */
    receivables: Array<MonthlyReceivables>;
    /**
     * 
     * @type {Array<MonthlyPayments>}
     * @memberof CompanyFinancialsResponse
     */
    payments: Array<MonthlyPayments>;
    /**
     * 
     * @type {Array<MonthlyRevenue>}
     * @memberof CompanyFinancialsResponse
     */
    revenue: Array<MonthlyRevenue>;
}

/**
 * Check if a given object implements the CompanyFinancialsResponse interface.
 */
export function instanceOfCompanyFinancialsResponse(value: object): value is CompanyFinancialsResponse {
    if (!('claims' in value) || value['claims'] === undefined) return false;
    if (!('receivables' in value) || value['receivables'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    return true;
}

export function CompanyFinancialsResponseFromJSON(json: any): CompanyFinancialsResponse {
    return CompanyFinancialsResponseFromJSONTyped(json, false);
}

export function CompanyFinancialsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyFinancialsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claims': ((json['claims'] as Array<any>).map(ClaimFinancialRowFromJSON)),
        'receivables': ((json['receivables'] as Array<any>).map(MonthlyReceivablesFromJSON)),
        'payments': ((json['payments'] as Array<any>).map(MonthlyPaymentsFromJSON)),
        'revenue': ((json['revenue'] as Array<any>).map(MonthlyRevenueFromJSON)),
    };
}

export function CompanyFinancialsResponseToJSON(json: any): CompanyFinancialsResponse {
    return CompanyFinancialsResponseToJSONTyped(json, false);
}

export function CompanyFinancialsResponseToJSONTyped(value?: CompanyFinancialsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claims': ((value['claims'] as Array<any>).map(ClaimFinancialRowToJSON)),
        'receivables': ((value['receivables'] as Array<any>).map(MonthlyReceivablesToJSON)),
        'payments': ((value['payments'] as Array<any>).map(MonthlyPaymentsToJSON)),
        'revenue': ((value['revenue'] as Array<any>).map(MonthlyRevenueToJSON)),
    };
}

